import { Outlet } from 'react-router-dom';
import { useToggleLocalStorage } from 'hooks/useToggleLocalStorage';
import { Box, CssBaseline } from '@mui/material';
import { Navbar } from 'components/layouts/main-layout/navbar/Navbar';
import { Sidebar } from 'components/layouts/main-layout/sidebar/Sidebar';
import { Drawer } from 'components/common/drawer/Drawer';
import { useDrawer } from 'contexts/DrawerContext';
import { useCloseOnRouteChange } from 'hooks/useCloseOnRouteChange';

export const MainLayout = () => {
  const { toggleValue, toggle } = useToggleLocalStorage({ name: 'agentspace.sidebar.wide', defaultValue: true });
  const { drawer, closeDrawer } = useDrawer();

  useCloseOnRouteChange(closeDrawer);

  const mainBoxStyles = {
    height: '92vh',
    width: drawer.show ? 'calc(100% - 362px)' : '100%',
    transition: 'width 0.3s linear',
    position: 'absolute',
  };

  return (
    <Box sx={{ display: 'flex', width: '100%', position: 'relative' }}>
      <CssBaseline />
      <Sidebar
        wide={toggleValue}
        toggleWide={toggle}
      />
      <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%', position: 'relative' }}>
        <Navbar
          wide={toggleValue}
          toggleWide={toggle}
        />
        <Box sx={{ width: '100%', height: '100%', marginTop: '65px', position: 'relative' }}>
          <Box
            component="main"
            sx={mainBoxStyles}
          >
            <Outlet />
          </Box>
          <Drawer
            open={drawer.show}
            component={drawer.component}
            close={closeDrawer}
            props={drawer.props}
          />
        </Box>
      </Box>
    </Box>
  );
};
